import { Textarea } from "@/components/ui/textarea";
import { calculateGrade } from "@/lib/utils";
import { ImprovementProposal } from "@/schema/improvement-proposal/ImprovementProposal";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface EvaluationRowProps {
  categoryIndex: number;
  subCategoryIndex: number;
}

function EvaluationRow({
  categoryIndex,
  subCategoryIndex,
}: EvaluationRowProps) {
  const { control } = useFormContext<ImprovementProposal>();
  const {
    field: {
      value: { content, score },
    },
  } = useController({
    control,
    name: `main_category_results.${categoryIndex}.sub_category_results.${subCategoryIndex}`,
  });
  const {
    field: { value: proposalNote, onChange },
  } = useController({
    control,
    name: `main_category_results.${categoryIndex}.sub_category_results.${subCategoryIndex}.proposal_note`,
  });
  const { t } = useTranslation();
  return (
    <div className=" flex flex-row space-x-6 px-4 py-6 items-center">
      <p className=" text-sm font-medium text-cool-gray-700 w-[200px]">
        {content}
      </p>
      {/* <div className=" flex flex-col space-y-[2.5] w-[96px]">
        <p className=" text-sm font-medium text-cool-gray-700">
          {score !== null && score !== undefined ? score : "--"}
        </p>
        <p className=" text-sm font-normal text-cool-gray-500">{t("points")}</p>
      </div> */}
      <div className="py-[16px] px-[24px]">
        <div>
          <span className="text-cool-gray-700 text-[14px] leading-[20px]  font-normal">
            {t("score")}{" "}
          </span>
          <span className="text-cool-gray-700 text-[14px] leading-[20px]  font-bold">
            {score ?? '--'}
          </span>
        </div>
        <div>
          <div className="bg-cool-gray-200 w-[100px] h-[8px] rounded-[8px]">
            <div
              className="bg-cyan-500 rounded-[8px] h-[8px]"
              style={{
                width: `${score ?? 0}%`,
              }}
            />
          </div>
        </div>
      </div>
      <div className=" flex flex-col space-y-[2.5] w-[96px]">
        <p className=" text-sm font-medium text-cool-gray-700">
          {calculateGrade(score)}
        </p>
        <p className=" text-sm font-normal text-cool-gray-500">{t("grade")}</p>
      </div>
      <Textarea
        value={proposalNote ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className=" flex-grow resize-none h-[58px]"
        placeholder="入力してください"
      />
    </div>
  );
}

export default EvaluationRow;
